module.exports = __webpack_public_path__ + "media/images/fields-icon-nav-hover-aef2358f126d2847b0b09df275ae147b.svg";